{
    "Profile_SideBar.policies": "Policies",
    "Profile_SideBar.summary": "Summary",
    "Profile_SideBar.terms": "Terms",
    "Profile_SideBar.underwriterCoverageAdjustment": "Underwriting",
    "Profile_SideBar.policy": "Policy",
    "Profile_SideBar.applicant": "Insured",
    "Profile_SideBar.insuranceApplicant": "Insurance Applicant",
    "Profile_SideBar.securemyoffer.secureMyOffer": "Secure My Offer",
    "Profile_SideBar.securemyoffer.insuranceApplicant": "Insurance Applicant",
    "Profile_SideBar.payment": "Payment",
    "Profile_SideBar.documents": "Documents",
    "Profile_SideBar.notes": "Notes",
    "Profile_SideBar.history": "History",
    "Profile_SideBar.logs": "API Logs",
    "Profile_SideBar.securemyoffer.additionalSellers": "Additional Sellers"
}
